import { useEffect, useState } from "react";
import { FaPhoneAlt, FaRegClock, FaSearch } from "react-icons/fa";
import FeedbackCarousel from "../components/FeedBackCarousel";
import { FiEye } from "react-icons/fi";
import { FaRegCalendar } from "react-icons/fa";
import { MdSpeed } from "react-icons/md";
import { BiGasPump } from "react-icons/bi";
import { LuMessageCircle } from "react-icons/lu";
import { FaCarAlt } from "react-icons/fa";
import { FaGear, FaLocationDot } from "react-icons/fa6";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  onSnapshot,
  getDoc,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FiltrosAvancados from "../components/FiltrosAvancados";
import BannerCarousel from "../components/BannersCarousel";
import { formatMoney } from "../utils/formatMoney";
import { Card, CardContent } from "../components/ui/Card";
import { FiShoppingCart as ShoppingCart, FiCreditCard as CreditCard } from "react-icons/fi";
import { FaAward as Award, FaUsers as Users } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { brands } from "../data/brands";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import { Bold } from "lucide-react";
import WhatsappFloatButton from "../components/WhatsappFloatButton";

const firestore = getFirestore(app);

export default function Home() {
  const [veiculos, setVeiculos] = useState([]);
  const [revenda, setRevenda] = useState({});
  const [filtros, setFiltros] = useState({ marca: "", modelo: "", ano: "" });
  const [filtrosAvancados, setFiltrosAvancados] = useState({
    tipo: "",
    cor: "",
    portas: "",
    kmMax: "",
    precoMin: "",
    precoMax: "",
  });

  const [searchParams] = useSearchParams();

  const marca = searchParams.get("vefipe_marca");

  const [, setErroFiltro] = useState("");

  const navigate = useNavigate();

  const [cars, setCars] = useState([]);

  const soldVehicles = [
    { src: "/vendidos/img01.jpg", title: "Vendido" },
    { src: "/vendidos/img02.jpg", title: "Vendido" },
    { src: "/vendidos/img03.jpg", title: "Vendido" },
    { src: "/vendidos/img04.jpg", title: "Vendido" },
    { src: "/vendidos/img05.jpg", title: "Vendido" },
    { src: "/vendidos/img06.jpg", title: "Vendido" },
    { src: "/vendidos/img07.jpg", title: "Vendido" },
    { src: "/vendidos/img08.jpg", title: "Vendido" },
    { src: "/vendidos/img09.jpg", title: "Vendido" },
    { src: "/vendidos/img10.jpg", title: "Vendido" },
  ];


  useEffect(() => {
    window.scrollTo(0, 0);

    const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
    getDoc(revendaRef).then((docSnap) => {
      if (docSnap.exists()) {
        setRevenda(docSnap.data());
      }
    });

    const q = query(
      collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
      where("veremovido", "==", 0),
      where("vevendido", "==", 0),
      orderBy("updated_at", "desc")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        const document = doc.data();
        document.id = doc.id;
        if (document["veexibir_site"] !== false) {
          items.push(document);
        }
      });
      setVeiculos(items);
    });

    return () => unsubscribe();
  }, []);

  function getOpcoesFiltro(campo, marcaSelecionada = "") {
    const modelosFiltrados = veiculos.filter((veiculo) => {
      if (campo === "vefipe_name" && marcaSelecionada) {
        return veiculo.vefipe_marca === marcaSelecionada;
      }
      return true;
    });

    const opcoes = modelosFiltrados
      .map((veiculo) => veiculo[campo])
      .filter((valor, index, self) => valor && self.indexOf(valor) === index);

    return opcoes.sort();
  }

  const handleBuscar = () => {
    if (
      !filtros.marca &&
      !filtros.modelo &&
      !filtros.ano &&
      !Object.values(filtrosAvancados).some((value) => value)
    ) {
      setErroFiltro("Selecione pelo menos um filtro.");
      return;
    }

    const params = new URLSearchParams();
    // Mapeia os nomes dos filtros para os nomes dos campos do veículo
    if (filtros.marca) params.append("vefipe_marca", filtros.marca);
    if (filtros.modelo) params.append("vefipe_name", filtros.modelo);
    if (filtros.ano) params.append("vefipe_ano_modelo", filtros.ano);

    Object.entries(filtrosAvancados).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    setErroFiltro("");
    navigate(`/estoque?${params.toString()}`);
  };

  function separarNomeVeiculo(nomeCompleto) {
    if (!nomeCompleto) return { mainName: '', subName: '' };

    const palavras = nomeCompleto.split(' ');

    const STOP_WORDS = [
      'CD', 'SR', 'SRV', 'GR', 'XEI', 'LTZ', 'LX',
      '4X4', '4X2',
      '1.0', '1.2', '1.3', '1.4', '1.5', '1.8', '1.6', '2.0', '2.8',
      'TDI', 'TURBO', 'DIESEL', 'FLEX',
      'AUT', 'AUT.', 'MT', 'CVT'
    ];

    const indexSpec = palavras.findIndex(p =>
      STOP_WORDS.includes(p)
    );

    if (indexSpec === -1) {
      return {
        mainName: palavras.slice(0, 2).join(' '),
        subName: palavras.slice(2).join(' ')
      };
    }

    return {
      mainName: palavras.slice(0, indexSpec).join(' '),
      subName: palavras.slice(indexSpec).join(' ')
    };
  }

  const filteblueCars = cars.filter((car) =>
    marca ? car.brand === marca : true
  );

  return (
    <div className="min-h-screen w-full bg-black">
      <Header />

      {/* HERO */}
      <BannerCarousel />

      {/* TEXTO */}
      {/*<section className="w-full flex flex-col items-center text-center mt-16 px-6">
        <h1 className="text-mega md:text-4xl font-extrabold mb-4">
          Alguma <span className="text-green-600">marca</span> em mente?
        </h1>

        <p className="text-gray-400 sm:text-lg md:text-xl max-w-xl">
          Com um clique você encontra o carro ideal para seu negócio!
        </p>
      </section>


      <section className="w-full mt-12 px-6">
        <div className="max-w-[1200px] mx-auto">

          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={32}
            slidesPerView={3}
            breakpoints={{
              640: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 5 },

            }}


          >
            {brands.map((brand) => (
              <SwiperSlide key={brand.slug} className="flex justify-center ">
                <Link
                  to={`/estoque?vefipe_marca=${brand.slug}`}
                  className="group flex items-center justify-center h-32"
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="
                    h-12 md:h-24
                    object-contain
                    opacity-60
                    grayscale
                    transition-all
                    duration-300
                    group-hover:opacity-100
                    group-hover:grayscale-0
                    group-hover:scale-105
                   
                  "
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section >*/}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300 h-[350px]">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <ShoppingCart className="text-green-700" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">Qualidade e Confiança</h3>
                <p className="text-white leading-relaxed">
                  Veículos da melhor qualidade, com procedência garantida!
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CreditCard className="text-green-700" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">Condições Comerciais Especiais</h3>
                <p className="text-white leading-relaxed">
                  Preços competitivos, volume facilitado e condições pensadas para você e sua família!
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="text-green-700" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">Segurança Garantida!</h3>
                <p className="text-white leading-relaxed">
                  Todos os veículos são revisados para a garantia de segurança de nossos clientes!
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="text-green-700" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">Atendimento B2B Especializado</h3>
                <p className="text-white leading-relaxed">
                  Consultores focados em revenda para agilizar negociações e reposição de estoque
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <section className="py-12 bg-black">
      <div className="relative flex flex-col items-center justify-center text-white text-center px-2 sm:px-4">
        <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-2 sm:mb-4">Carros em <span className="text-green-500">Destaque</span>
        </h1>
        <p className="text-gray-400 sm:text-lg md:text-xl mb-4 sm:mb-8">
          Confira nossa seleção de veículos premium disponíveis para você
        </p>


      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-6 max-w-6xl mx-auto px-4">
        {veiculos
          .slice()
          .sort(() => Math.random() - 0.5)
          .slice(0, 3)
          .map((veiculo) => {

            const { mainName, subName } = separarNomeVeiculo(
              veiculo.vefipe_name
            );

            const cambio = veiculo.vecambio === 'A' ? 'Automático' : veiculo.vecambio === 'M' ? 'Manual' : veiculo.vecambio;

            veiculo.vecambio = cambio;

            return (
              <div key={veiculo.id} className="bg-neutral-950/80 rounded-2xl border border-green-600/25 shadow-lg overflow-hidden flex flex-col h-[110%]">
                <img className="object-contain w-full h-48 md:h-64 lg:h-72 bg-black" src={veiculo.imagens[0]?.fileUrl} alt={veiculo.titulo} />

                <div className="p-5 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-lg font-bold uppercase text-white">
                      {veiculo.vefipe_marca} {mainName}
                    </h3>

                    {subName && (
                      <p className="text-sm text-gray-400 uppercase">
                        {subName}
                      </p>
                    )}
                  </div>

                  <div className="grid grid-cols-2 text-gray-400 space-y-2 text-sm">
                    <span className="flex items-center gap-1">
                      <MdSpeed /> {veiculo.vequilometragem}km
                    </span>
                    <span className="flex items-center gap-1">
                      <BiGasPump /> {veiculo.vefipe_combustivel}
                    </span>
                    <span className="flex items-center gap-1">
                      <FaRegCalendar /> {veiculo.veano_fabricacao} / {veiculo.vefipe_ano_modelo}
                    </span>
                    <span className="flex items-center gap-1">
                      <FaGear /> {veiculo.vecambio}
                    </span>
                  </div>

                  <hr className="border-green-600/30" />
                  <div className="mt-2 flex gap-4 items-center justify-between">
                    <p className="text-xl font-bold text-green-500">
                      {veiculo.vevalor
                        ? formatMoney(veiculo.vevalor)
                        : 'Consulte o preço'}
                    </p>


                    <a
                      href={`/veiculo/${veiculo.id}`}
                      className="bg-green-600 hover:bg-green-500 text-black px-4 py-2 rounded flex gap-2 items-center font-semibold transition-colors"
                    >
                      <FiEye /> Ver Detalhes
                    </a>

                  </div>
                </div>
              </div>
            );
          })}

      </div>
      </section>

      <section className="bg-green-500 py-8 px-6 mt-10">
        <div className="max-w-7xl mx-auto grid grid-cols-3 gap-8 text-center">
          {[["20+", "Veículos em estoque"], ["98%", "Clientes satisfeitos"], ["5+ anos", "No mercado premium"]].map(([v, l]) => (
            <div key={l}>
              <p className="text-black text-3xl font-black">{v}</p>
              <p className="text-black/60 text-xs uppercase tracking-widest mt-1">{l}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16 bg-black">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
            <div>
              <p className="text-green-500 uppercase tracking-widest text-xs font-semibold">
                Veículos Vendidos
              </p>
              <h2 className="text-3xl md:text-4xl font-extrabold text-white">
                Negócios fechados com <span className="text-green-500">qualidade</span>
              </h2>
            </div>
            <p className="text-gray-400 max-w-md">
              Um recorte dos carros que já passaram pela nossa curadoria e saíram
              daqui direto para novos proprietários.
            </p>
          </div>

          <div className="rounded-3xl border border-green-600/30 bg-gradient-to-br from-black via-neutral-950 to-green-950/40 p-5 md:p-8">
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation
              autoplay={{ delay: 2800, disableOnInteraction: false }}
              spaceBetween={24}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {soldVehicles.map((item, index) => (
                <SwiperSlide key={`${item.title}-${index}`}>
                  <div className="group relative overflow-hidden rounded-2xl bg-neutral-900/60 border border-green-600/20">
                    <img
                      src={item.src}
                      alt={item.title}
                      className="h-72 md:h-80 w-full object-contain bg-neutral-900 group-hover:scale-105 transition-transform duration-500"
                    />
                    
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>

      <section className="bg-black">

        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[60%] h-px bg-gradient-to-r from-transparent via-green-600/60 to-transparent" />
        <FeedbackCarousel />
      </section>
<WhatsappFloatButton />

      <Footer />
    </div >
  );
}
